// extracted by mini-css-extract-plugin
export default {"title":"style_title__kr-zy","itemWrapper":"style_itemWrapper__olGkZ","fieldsBullet":"style_fieldsBullet__vxTpE","fieldsHintLabel":"style_fieldsHintLabel__ZCb77"};